/**
 * @generated SignedSource<<79e8590ee83d49aa1b96493fe9d96650>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentMenuItemEditPageQuery$variables = {
  id: string;
};
export type ContentMenuItemEditPageQuery$data = {
  readonly menuItem: {
    readonly menu: {
      readonly displayName: string;
      readonly id: string;
    };
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity" | "MenuItemsEditForm_menuItem">;
  } | null;
};
export type ContentMenuItemEditPageQuery = {
  response: ContentMenuItemEditPageQuery$data;
  variables: ContentMenuItemEditPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Menu",
  "kind": "LinkedField",
  "name": "menu",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContentMenuItemEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MenuItem",
        "kind": "LinkedField",
        "name": "menuItem",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EntitySidebar_entity"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MenuItemsEditForm_menuItem"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentMenuItemEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MenuItem",
        "kind": "LinkedField",
        "name": "menuItem",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "icon",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2ab1422aa18a8eb0213e1a778d2233bc",
    "id": null,
    "metadata": {},
    "name": "ContentMenuItemEditPageQuery",
    "operationKind": "query",
    "text": "query ContentMenuItemEditPageQuery(\n  $id: ID!\n) {\n  menuItem(id: $id) {\n    name\n    menu {\n      id\n      displayName\n    }\n    ...EntitySidebar_entity\n    ...MenuItemsEditForm_menuItem\n    id\n  }\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment MenuItemsEditForm_menuItem on MenuItem {\n  id\n  name\n  type\n  icon\n  url\n}\n"
  }
};
})();

(node as any).hash = "533ecd00cb1c2f97deee56e69f557a68";

export default node;
